import React, { useEffect, useState } from 'react';
import Accordion from 'react-bootstrap/Accordion';
import demoImg from "../../Assetes/Images/burgimg.jpg";
import Button from '@mui/material/Button';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import { Link } from 'react-router-dom';
import DimyImg2 from '../../Assetes/Images/dimy-2.webp'
import { connect, useSelector } from 'react-redux';
import _ from 'lodash';
import { toast } from 'react-toastify';
import { getCart, saveCart } from '../../Redux';
import { BASE_URL, IMAGE_URL, priceunit } from '../../Components/client-config';
import mergn from 'mergn-webapp-sdk';
import useTrackEvent from '../../hooks/useTrackHook';
import ModalSkelton from '../../Assetes/SkeletonLoader/ModalSkelton';
import { useTranslation } from 'react-i18next';

function ComboMenuBox(props: any) {
    let [itemQuantity, setItemQuantity] = useState(1);
    let [modifiers, setModifiers]: any = useState(null);
    let [comboDetails, setComboDetails]: any = useState(null);
    let [initialPrice, setInitialPrice]: any = useState("");
    let [itemPrice, setItemPrice]: any = useState("");
    let [prevMod, setPrevMod]: any = useState("");
    let [prevKey, setPrevKey]: any = useState("");
    const [value, setValue] = useState(0);
    const comboData = useSelector((state: any) => state.menu.comboData);
    let cartData = useSelector((state: any) => state.cart.cartData);
    const storeSelected = useSelector((state: any) => state.store.storeSelected);
    const [addEvent] = useTrackEvent();
    const { t } = useTranslation();
    useEffect(() => {
        if (!_.isEmpty(comboData)) {
            setModifiers(comboData.modifiers)
            setItemPrice(((comboData.discount_price || comboData.discount_price == 0) && (comboData.order_channel == 'online')) ? Math.round(comboData.discount_price) : Math.round(comboData.combo_mrp_price))
            setInitialPrice(((comboData.discount_price || comboData.discount_price == 0) && (comboData.order_channel == 'online')) ? Math.round(comboData.discount_price) : Math.round(comboData.combo_mrp_price))
        }
    }, [comboData])
    function incrementItemQuantity() {
        itemQuantity = itemQuantity + 1;
        setItemQuantity(itemQuantity);
        let itemNetPrice = ((comboData.discount_price || comboData.discount_price == 0) && (comboData.order_channel == 'online')) ? Math.round(comboData.discount_price) : Math.round(comboData.combo_mrp_price)
        setItemPrice(itemPrice + itemNetPrice)
    }
    function decrementItemQuantity() {
        if (itemQuantity > 1) {
            itemQuantity = itemQuantity - 1;
            setItemQuantity(itemQuantity);
            let itemNetPrice = ((comboData.discount_price || comboData.discount_price == 0) && (comboData.order_channel == 'online')) ? Math.round(comboData.discount_price) : Math.round(comboData.combo_mrp_price)
            setItemPrice(itemPrice - itemNetPrice)
        }
    }
    function addModifier(key: any, modifier_name: any) {
        let prevPrice = 0;
        modifiers[key].map((element: any) => {
            let modPrice = ((element.discount_price || element.discount_price == 0) && (element.order_channel == 'online')) ? Math.round(element.discount_price) : element.modifier_sale_price;
            if (element.selected == true) {
                prevPrice = modPrice;
            }
            if (element.modifier_name !== modifier_name) {
                element.selected = false;
            }
        })
        modifiers[key].map((item: any, index: any) => {
            if (modifier_name == item.modifier_name) {
                let modPrice = ((item.discount_price || item.discount_price == 0)) ? Math.round(item.discount_price) : item.modifier_sale_price;
                if (prevMod == '') {
                    setItemPrice(parseInt(itemPrice) + modPrice)
                    setPrevMod(modifier_name)
                    setPrevKey(key)
                    setValue(value => value + 1);  //ForceFull Render component at price 0
                    item.selected = true
                } else {
                    if (prevKey == key) {
                        item.selected = !item.selected;
                        if (prevMod === modifier_name) {
                            if (item.selected == true) {
                                setItemPrice(parseInt(itemPrice) - prevPrice + modPrice)
                                setPrevMod(modifier_name)
                                setPrevKey(key)
                                setValue(value => value + 1);  //ForceFull Render component at price 0
                            } else {
                                setItemPrice(parseInt(itemPrice) - prevPrice)
                                setPrevMod(modifier_name)
                                setPrevKey(key)
                                setValue(value => value + 1);  //ForceFull Render component at price 0
                            }
                        }
                        else {
                            setItemPrice(parseInt(itemPrice) - prevPrice + modPrice)
                            setPrevMod(modifier_name)
                            setPrevKey(key)
                            setValue(value => value + 1);  //ForceFull Render component at price 0
                        }
                    } else {
                        item.selected = true;
                        setItemPrice(parseInt(itemPrice) - prevPrice + modPrice)
                        setPrevMod(modifier_name)
                        setPrevKey(key)
                        setValue(value => value + 1);  //ForceFull Render component at price 0
                    }
                }
            }
        })
    }
    function handleCheck(key: any, modName: any) {
        let max_quantity = 0;
        let allowed_quantity = 0;
        modifiers[key].map((element: any) => {
            if (element.selected == true) {
                max_quantity += element.quantity;
            }
            else {
                allowed_quantity = element.modGroup_max_quantity;
            }
        })
        modifiers[key].map((item: any, index: any) => {
            if (item.modifier_name == modName) {
                let modPrice = ((item.discount_price || item.discount_price == 0)) ? Math.round(item.discount_price) : item.modifier_sale_price;
                if (item.selected == false) {
                    if (max_quantity < allowed_quantity) {
                        item.selected = !item.selected;
                        setItemPrice(parseInt(itemPrice) + modPrice * item.quantity)
                        setModifiers(modifiers)
                        setValue(value => value + 1);  //ForceFull Render component at price 0
                    }
                } else {
                    item.selected = !item.selected;
                    setItemPrice(parseInt(itemPrice) - modPrice * item.quantity)
                    setModifiers(modifiers)
                    setValue(value => value + 1);  //ForceFull Render component at price 0
                }
            }
        });

    };
    function decrementQuantity(key: any, modName: any) {
        modifiers[key].map((item: any, index: any) => {
            if (item.modifier_name == modName) {
                if (item.quantity == 1) {
                    return;
                }
                else {
                    item.quantity -= 1;
                    setModifiers(modifiers);
                    setItemPrice(parseInt(itemPrice) - item.modifier_sale_price)
                }
            }
        });
    }
    function incrementQuantity(key: any, modName: any) {
        let max_quantity = 0;
        let allowed_quantity = 0;
        modifiers[key].map((element: any) => {
            if (element.selected == true) {
                max_quantity += element.quantity;
            }
            allowed_quantity = element.modGroup_max_quantity;
        })
        modifiers[key].map((item: any, index: any) => {
            if (item.modifier_name == modName) {
                if (max_quantity < allowed_quantity) {
                    item.quantity += 1;
                    setModifiers(modifiers);
                    setItemPrice(parseInt(itemPrice) + item.modifier_sale_price)
                }
            }
        });
    }
    // function itemReady() {
    //     //For only crusts and Toppings and other addons
    //     let quantityFlag = true;
    //     let foundModifier = false;
    //     if (!_.isEmpty(modifiers)) {
    //         Object.keys(modifiers).map(key => {
    //             let ModifierQuantityCount = 0
    //             if (quantityFlag) {
    //                 for (let i = 0; i < modifiers[key].length; i++) {
    //                     if (modifiers[key][i].modGroup_min_quantity > 0) {
    //                         if (modifiers[key][i].selected && modifiers[key][i].quantity > 0) {
    //                             ModifierQuantityCount += modifiers[key][i].quantity;
    //                         }
    //                         if (i == modifiers[key].length - 1) {
    //                             if (ModifierQuantityCount < modifiers[key][i].modGroup_min_quantity) {
    //                                 if (!foundModifier) {
    //                                     // toast.warn("Please select max quantity for required option in " + modifiers[key][i].mod_group_name, { position: toast.POSITION.TOP_RIGHT, hideProgressBar: true, autoClose: 3000 })
    //                                     foundModifier = true;
    //                                     quantityFlag = false;
    //                                     break;
    //                                 }
    //                             }
    //                             else {
    //                                 quantityFlag = true;
    //                             }
    //                         }
    //                     }
    //                 }
    //             }
    //         })
    //     }
    //     else {
    //         quantityFlag = true;
    //     }
    //     return quantityFlag
    // }
    //here
    function itemReady() {
        // For only crusts and Toppings and other addons
        let quantityFlag = true;
        let foundModifier = false;
        if (!_.isEmpty(modifiers)) {
            Object.keys(modifiers).forEach(key => {
                let ModifierQuantityCount = 0;

                if (quantityFlag) {
                    modifiers[key].forEach((modifier: any, i: any) => {
                        if (modifier.modGroup_min_quantity > 0) {
                            if (modifier.selected && modifier.quantity > 0) {
                                ModifierQuantityCount += modifier.quantity;
                            }

                            if (i === modifiers[key].length - 1) {
                                if (ModifierQuantityCount < modifier.modGroup_min_quantity) {
                                    if (!foundModifier) {
                                        // toast.warn("Please select max quantity for required option in " + modifier.mod_group_name, { position: toast.POSITION.TOP_RIGHT, hideProgressBar: true, autoClose: 3000 })
                                        foundModifier = true;
                                        quantityFlag = false;
                                    }
                                } else {
                                    quantityFlag = true;
                                }
                            }
                        }
                    });
                }
            });
        } else {
            quantityFlag = true;
        }
        return quantityFlag;
    }

    const handleAddToCart = (product: any) => {

        const makeItem = {
          name: product.combo_name ? product.combo_name : product.item_name,
          price: product.combo_name ? product.combo_mrp_price : product.item_size[0].mrp,
          category: product?.item_group_id ? product?.item_group_id?.group_name : product.group_id?.group_name,
          url : {
              page: `${BASE_URL}menu#${product.combo_id ? 'combo' : 'item'}/${product.combo_name ? product.combo_name.replace(/\s+/g, '') :  product.item_name.replace(/\s+/g, '')}_${product.combo_id ? product.combo_id : product.menu_item_id }`,
              product: `${IMAGE_URL}${product.combo_name ? product.image_url : product.item_size[0].image_url}`
          }
        }
    
        mergn.recordEvent("Add to Bucket", [
          { eventProperty: 'product-name', value: makeItem.name },
          { eventProperty: 'product-price', value: makeItem.price },
          { eventProperty: 'category-name', value: makeItem.category },
          { eventProperty: 'product-page-url', value: makeItem.url.page },
          { eventProperty: 'product-image-url', value: makeItem.url.product }
        ])
    
    }

    function handleAdd(combo: any) {
        handleAddToCart(combo)
        props.handleToogle()
        let itemReadyFlag = itemReady();
        if (itemReadyFlag) {
            //For Normal Item Add to cart
            if (_.isEmpty(storeSelected)) {
                props.setSelectStoreModal(true)

            }
            if (!_.isEmpty(combo)) {
                let discounted_item: any = false;
                let cart: any = cartData;

                if (combo.is_active == 1) {
                    if ((combo.discount_price || combo.discount_price == 0) && (combo.order_channel == "all" || combo.order_channel == "online")) {
                        discounted_item = true;
                    } else {
                        discounted_item = false;
                    }

                    if (!_.isEmpty(cart)) {
                        // let modifierFound = false;
                        // let found = false;
                        // cart.forEach((element: any) => {
                        //     if (element["combo"]) {
                        //         if (element["combo"].combo_id == combo.combo_id) {
                        //             let itemModifiers = combo.modifiers;
                        //             if (itemModifiers !== undefined) {
                        //                 Object.keys(itemModifiers).map((key) => {
                        //                     itemModifiers[key].map((obj: any) => {
                        //                         if (obj.selected) {
                        //                             modifierFound = true;
                        //                             found = true;
                        //                             return
                        //                         }
                        //                     })
                        //                 })
                        //                 if (modifierFound) {
                        //                     const itemcart: any = {
                        //                         combo: combo,
                        //                         quantity: itemQuantity,
                        //                         price: Math.round(initialPrice),
                        //                         totalItemPrice: Math.round(itemPrice),
                        //                         modifiers: modifiers,
                        //                         image: combo.images.length > 0 ? combo.images[0].image_url : '',
                        //                         collapseIn: false
                        //                     };
                        //                     cart.push(itemcart);
                        //                 } else {
                        //                     element.quantity = element.quantity + itemQuantity;
                        //                     let itemNetPrice = ((comboData.discount_price || comboData.discount_price == 0) && (comboData.order_channel == 'online')) ? Math.round(comboData.discount_price) : Math.round(comboData.combo_mrp_price)
                        //                     element.totalItemPrice = (itemNetPrice * itemQuantity) + element.totalItemPrice;
                        //                 }
                        //             } else {
                        //                 element.quantity = element.quantity + itemQuantity;
                        //                 let itemNetPrice = ((comboData.discount_price || comboData.discount_price == 0) && (comboData.order_channel == 'online')) ? Math.round(comboData.discount_price) : Math.round(comboData.combo_mrp_price)
                        //                 element.totalItemPrice = (itemNetPrice * itemQuantity) + element.totalItemPrice;
                        //             }
                        //         }
                        //     }
                        // });
                        // if (!found) {
                        //     const itemcart: any = {
                        //         combo: combo,
                        //         quantity: itemQuantity,
                        //         price: Math.round(initialPrice),
                        //         totalItemPrice: Math.round(itemPrice),
                        //         modifiers: modifiers,
                        //         image: combo.images.length > 0 ? combo.images[0].image_url : '',
                        //         collapseIn: false
                        //     };
                        //     cart.push(itemcart);
                        // }
                        const itemcart: any = {
                            combo: combo,
                            quantity: itemQuantity,
                            price: Math.round(initialPrice),
                            totalItemPrice: Math.round(itemPrice),
                            modifiers: modifiers,
                            image: combo.images.length > 0 ? combo.images[0].image_url : '',
                            collapseIn: false
                        };
                        cart.push(itemcart);
                    } else {
                        const itemcart: any = {
                            combo: combo,
                            quantity: itemQuantity,
                            price: Math.round(initialPrice),
                            totalItemPrice: Math.round(itemPrice),
                            modifiers: modifiers,
                            image: combo.images.length > 0 ? combo.images[0].image_url : '',
                            collapseIn: false
                        };
                        cart.push(itemcart);
                    }

                    props.saveCart(cart);
                    let products: any = []
                    let MapObj: any = {}
                    MapObj = {
                        item_id: combo.combo_id,
                        item_name: combo.combo_name,
                        item_category: combo.group_id.group_name,
                        discount: combo?.discount_value ? combo.discount_value : 0,
                        quantity: itemQuantity,
                        price: Math.round(initialPrice),
                    }
                    products.push(MapObj)
                    let windowObj = (window as any)
                    windowObj.dataLayer.push({ ecommerce: null });
                    windowObj.dataLayer.push({
                        'event': 'add_to_cart',
                        'ecommerce': {
                            currency: 'PKR',
                            value: Math.round(itemPrice),
                            items: products
                        }
                    });
                    setPrevMod(0)
                    setItemQuantity(1)
                    if (storeSelected) {
                        toast.success(`${combo.combo_name} ${t("ADDED_TO_CART")}`, {
                            position: toast.POSITION.TOP_RIGHT,
                            hideProgressBar: true,
                            autoClose: 3000
                        });
                        if (!_.isEmpty(storeSelected) && props.setShowSuggestiveDeal) {
                            if (combo.child_products && combo.child_products.length > 0) {
                                combo.child_products.forEach((obj: any) => {
                                    if (obj.is_lsm == 1 && obj.is_active == 1) {
                                        return storeSelected && obj.itemStores.length > 0 && obj.itemStores.map((obj2: any) => {
                                            if ((obj2.store_id.store_id == storeSelected.store_id) && obj.is_active == 1) {
                                                setTimeout(() => {
                                                    props.setShowSuggestiveDeal(true)
                                                }, 500)
                                            }
                                        })
                                    } else if (obj.is_lsm == 0 && obj.is_active == 1) {
                                        setTimeout(() => {
                                            props.setShowSuggestiveDeal(true)
                                        }, 500)
                                    } else if (obj.is_lsm === 2 && obj.is_active == 1) {
                                        let exist = false;
                                        let timeoutSet = false;

                                        obj.itemStores.forEach((obj2: any) => {
                                            if (obj2.store_id.store_id == storeSelected.store_id && obj.is_active === 1) {
                                                exist = true;
                                            }
                                        });

                                        if (!exist && !timeoutSet) {
                                            setTimeout(() => {
                                                props.setShowSuggestiveDeal(true);
                                            }, 500);
                                            timeoutSet = true;
                                        }
                                        return null;
                                    }
                                })
                            }
                        }
                        addEvent({ category: "events", events: `${combo?.combo_name} add to cart` })
                    }
                } else {
                    if (storeSelected) {
                        toast.error(t("ITEM_NOT_AVAILABLE"), {
                            position: toast.POSITION.TOP_RIGHT,
                            hideProgressBar: true,
                            autoClose: 3000
                        });
                    }
                }
            }
            props.handleClose();

        } else {
            toast.error(t("SELECT_REQUIRED_OPTIONS"), { position: toast.POSITION.TOP_RIGHT, hideProgressBar: true, autoClose: 3000 });
        }
    };
    return (
      <>
        {comboData && !_.isEmpty(comboData) ? (
          <div className="row">
            <>
              {" "}
              <div className="col-lg-7 order-set">
                <div className="menu-box">
                  <div className="item-name">
                    <Accordion defaultActiveKey="0">
                      {!_.isEmpty(comboData) &&
                        modifiers &&
                        Object.keys(modifiers).map((key, index) => {
                          return (
                            <Accordion.Item eventKey={`${index}`}>
                              <Accordion.Header className="w-100 d-flex chose-btn bg-theme p-2">
                                <div className="d-flex justify-content-between align-items-center w-100">
                                  <h5 className="mb-0"> {key}</h5>
                                  <span className="h6 mb-0 ">
                                    (
                                    {modifiers[key][0].modGroup_min_quantity ==
                                    0
                                      ? `${t("OPTIONAL")}`
                                      : <>{modifiers[key].length > 1 && `${t("REQUIRED")}`}</>
                                    } )
                                  </span>
                                </div>
                              </Accordion.Header>
                              <Accordion.Body>
                                {modifiers[key][0].modifier_type == "single" ? (
                                  <FormControl className="w-100">
                                    {modifiers[key].map((items: any) => {
                                      return (
                                        <RadioGroup
                                          aria-labelledby="demo-radio-buttons-group-label"
                                          name="radio-buttons-group"
                                          onChange={() =>
                                            addModifier(
                                              key,
                                              items.modifier_name
                                            )
                                          }
                                          className="w-100"
                                        >
                                          <FormControlLabel
                                            className="radio-check w-100"
                                            checked={items.selected}
                                            control={<Radio />}
                                            label={
                                              <div className="d-flex justify-content-between align-items-center w-100">
                                                {items.modifier_name}{" "}
                                                {items.modifier_sale_price >
                                                  0 && (
                                                  <>
                                                    {modifiers[key].length > 1 && (
                                                  <h6 className="color-white mb-0 def-rs">
                                                    +{priceunit}
                                                    {items.modifier_sale_price}
                                                      </h6>
                                                  )}
                                                  </>
                                                )}
                                              </div>
                                            }
                                          />
                                        </RadioGroup>
                                      );
                                    })}
                                  </FormControl>
                                ) : (
                                  modifiers[key].map((items: any) => {
                                    return (
                                      <div className="extra-add mt-1">
                                        <img
                                          src={`${IMAGE_URL}${items.image_url}`}
                                          alt={items?.modifier_name}
                                        />
                                        <div className="d-flex justify-content-between align-items-center w-100">
                                          <div className="kfc-add-box">
                                            <span>{items.modifier_name}</span>
                                            {items.modifier_sale_price > 0 && (
                                              <h6 className="def-rs">
                                                (+{priceunit}
                                                {items.modifier_sale_price})
                                              </h6>
                                            )}
                                          </div>
                                          {!items.selected ? (
                                            <Button
                                              className="bg-theme"
                                              onClick={() =>
                                                handleCheck(
                                                  key,
                                                  items.modifier_name
                                                )
                                              }
                                              variant="contained"
                                              color="error"
                                            >
                                              {t("ADD")}
                                            </Button>
                                          ) : (
                                            <div className="extra-add">
                                              {items.quantity === 1 ? (
                                                <Button
                                                  className="incre-btn dec-btn"
                                                  onClick={() =>
                                                    handleCheck(
                                                      key,
                                                      items.modifier_name
                                                    )
                                                  }
                                                  color="error"
                                                >
                                                  <i className="ri-delete-bin-line"></i>
                                                </Button>
                                              ) : (
                                                <Button
                                                  className="incre-btn dec-btn"
                                                  onClick={() =>
                                                    decrementQuantity(
                                                      key,
                                                      items.modifier_name
                                                    )
                                                  }
                                                  color="error"
                                                >
                                                  <i className="ri-subtract-line"></i>
                                                </Button>
                                              )}
                                              <h6 className="m-0">
                                                {items.quantity}
                                              </h6>
                                              <Button
                                                className="incre-btn dec-btn"
                                                onClick={() =>
                                                  incrementQuantity(
                                                    key,
                                                    items.modifier_name
                                                  )
                                                }
                                                color="error"
                                              >
                                                <i className="ri-add-line"></i>
                                              </Button>
                                            </div>
                                          )}
                                        </div>
                                      </div>
                                    );
                                  })
                                )}
                              </Accordion.Body>
                            </Accordion.Item>
                          );
                        })}
                    </Accordion>
                  </div>
                </div>
                <div className="motal-cart-mobile">
                  <Link to="#" onClick={() => handleAdd(comboData)}>
                    <span>{t("ADDTOBUCKET")}</span>
                    <h6>
                      {Math.round(itemPrice) < 0
                        ? priceunit + "0"
                        : priceunit + Math.round(itemPrice)}
                    </h6>
                    <i className="ri-arrow-right-s-line errow-line"></i>
                  </Link>
                </div>
              </div>
              <div className="col-lg-5">
                <div className="items-prices">
                  {!_.isEmpty(comboData) && comboData.images.length > 0 && (
                    <div className="item-img">
                      <img
                        alt={
                          comboData.alt_text
                            ? comboData.alt_text
                            : comboData.combo_name
                        }
                        src={`${IMAGE_URL}${comboData.images[0].image_url}`}
                      />
                    </div>
                  )}
                  <div className="shadow-img"></div>

                  <div className="main-heading">
                    <h2>{comboData.combo_name}</h2>
                    <p>{comboData.combo_description}</p>
                  </div>
                  <div className="menu-add-more">
                    {itemQuantity === 1 ? (
                      <Button
                        className="add-btn p-0 color-white"
                        disabled
                        color="error"
                      >
                        <i className="ri-subtract-line color-white"></i>
                      </Button>
                    ) : (
                      <Button
                        className="add-btn p-0 color-white"
                        onClick={decrementItemQuantity}
                        color="error"
                      >
                        <i className="ri-subtract-line color-white"></i>
                      </Button>
                    )}
                    <span className="cont-item">{itemQuantity}</span>
                    <Button
                      className="add-btn p-0 color-white"
                      onClick={incrementItemQuantity}
                      color="error"
                    >
                      <i className="ri-add-line"></i>
                    </Button>
                  </div>
                  <Link
                    className="motal-cart-btn"
                    to="#"
                    onClick={() => handleAdd(comboData)}
                  >
                    <span>
                      {" "}
                      {Math.round(itemPrice) < 0
                        ? priceunit + "0"
                        : priceunit + Math.round(itemPrice)}
                    </span>
                    <span>{t("ADDTOBUCKET")}</span>
                    <i className="ri-arrow-right-s-line errow-line"></i>
                  </Link>
                </div>
              </div>
            </>
          </div>
        ) : (
          <ModalSkelton />
        )}
      </>
    );
}
const mapDispatchToProps = (dispatch: any) => {
    return {
        getCart: function () {
            dispatch(getCart());
        },
        saveCart: function (cart: any[]) {
            dispatch(saveCart(cart));
        }
    };
};

export default connect(null, mapDispatchToProps)(ComboMenuBox);